import {format} from "../utils/forMat"
export default {
  data(){
    return {
      formInline:{
        startDate:'',
        endDate:'',
        time: ""
      },
      pickerOptions: {
        disabledDate(time) {
           return time.getTime() > Date.now();
       },

      },
    }
  },
  created(){
    this.setDefaultDate(); //默认这是一天
  },
  methods:{
    setDefaultDate(){
      //当前设定的日期时间
      let d = new Date
      //前一天设定的日期时间
      let year2,month2,day2
      d.setTime(d.getTime());
      [year2,month2,day2] = [d.getFullYear(),d.getMonth(),d.getDate()]
      let timeChanges = new Date(year2,month2,day2,0);
      this.formInline.startDate = format(timeChanges,"yyyy-MM-dd")
      this.formInline.time=this.formInline.startDate;
      this.formInline.endDate = this.formInline.startDate;
  },
  }
}